import React from "react";
import { Route, Routes } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import { LayoutDashboard, ClipboardList, Users, MapPinned } from "lucide-react";
import Overview from "@/pages/office/Overview";
import LeadsPage from "@/pages/shared/LeadsPage";
import VisitsPage from "@/pages/shared/VisitsPage";
import ExecutivesView from "@/pages/office/ExecutivesView";

const NAV = [
  { to: "/office", key: "dashboard", icon: LayoutDashboard, end: true },
  { to: "/office/leads", key: "leads", icon: ClipboardList },
  { to: "/office/visits", key: "visits", icon: MapPinned },
  { to: "/office/executives", key: "executives", icon: Users },
];

export default function OfficeDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout title="OFFICE STAFF" nav={NAV} testIdPrefix="office-nav" />}>
        <Route index element={<Overview />} />
        <Route path="leads" element={<LeadsPage role="office" />} />
        <Route path="visits" element={<VisitsPage />} />
        <Route path="executives" element={<ExecutivesView />} />
      </Route>
    </Routes>
  );
}
